import React, { useEffect, useState } from "react";
import { AiTwotoneCalendar } from "react-icons/ai";
import { NavLink, useNavigate } from "react-router-dom";
import ManmohanPhoto from "../components/assets/images/my photo.jpg";

export const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [pageSettings ,setPageSettings] = useState("")

  console.log(blogs);
  

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch("https://notesmania.in/api/theme_setting/blog-setting.php", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) throw new Error("Failed to fetch blogs.");

        const data = await response.json();
        setPageSettings(data.data);
        setLoading(false);
      } catch (error) {
        // console.error("Error fetching blogs:", error);
        setError(error.message);
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch("https://notesmania.in/api/website_blogs.php", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
  
        if (!response.ok) throw new Error("Failed to fetch blogs.");
  
        const data = await response.json();
        setBlogs(data);  // ✅ safety check
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };
  
    fetchBlogs();
  }, []);
  

  const handleBlogClick = (slug) => {
    navigate(`/blog/${slug}`); // Navigate to blog details page on click
  };

  if (loading)
    return (
      <p>
        {" "}
        <div className="main-loading">
          <div class="spacecraft-loading">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
            <div class="orbit"></div>
          </div>
        </div>
      </p>
    );
  if (error) return <p>Error: {error}</p>;

  return (
    <section className="courses">
      <div className="w-4/5 m-auto">
        <div className="heading text-center pb-12">
          <h1 className="text-3xl font-semibold text-black">
           {pageSettings.title}
          </h1>
          <span className="text-sm mt-2 block">
          {pageSettings.bio}
          </span>
        </div>
        <div className="grid grid-cols-3 gap-5 md:grid-cols-1">
     {blogs.map((item) => {
  const tags = JSON.parse(item.tags || "[]");

  return (
    <div
      key={item.id}
      className="box rounded-lg shadow-lg bg-white cursor-pointer"
      onClick={() => handleBlogClick(item.slug)}
    >
      <div className="images rounded-t-lg overflow-hidden h-40">
        <img
          src={`${process.env.REACT_APP_BASE_URL}/${item.thumbnail_url}`}
          alt={item.blog_name}
          className="rounded-t-lg object-cover w-full h-full transition-transform duration-300 hover:scale-110"
        />
      </div>

      <div className="text p-4">
        <div className="keywords flex flex-wrap gap-2 mb-2">
          {tags.map((tag: any, index: number) => (
            <span
              key={index}
              className="bg-gray-800 text-white px-3 py-1 rounded-md text-sm"
            >
              {tag.label}
            </span>
          ))}
        </div>

        <h3 className="text-lg font-medium my-4">{item.blog_name?.split(" ").slice(0, 10).join(" ")}</h3>

        <div className="user flex justify-between items-center">
          <div className="flex items-center">
            <img
              className="w-8 h-8 rounded-full"
              src={ManmohanPhoto}
              alt="Author"
            />
            <span className="ml-2 text-sm">Notesmania</span>
          </div>
          <div className="flex items-center text-sm text-gray-600 gap-1">
            <AiTwotoneCalendar />
            {new Date(item.created_at).toLocaleDateString()}
          </div>
        </div>
      </div>
    </div>
  );
})}

        </div>
      </div>
    </section>
  );
};
